export default __webpack_public_path__ + "static/media/train52.c60ad81f.png";